"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrictScriptWrapper = exports.ScriptWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var api_1 = require("../../../api");
var ScriptWrapper = function (_a) {
    var strict = _a.strict, children = _a.children;
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    (0, api_1.useScript)(api_1.ITEMS_API_URL);
    (0, api_1.useScript)(api_1.AUTHORING_API_URL);
    var reportsStatus = (0, api_1.useScript)(api_1.REPORTS_API_URL);
    (0, react_1.useEffect)(function () {
        if (reportsStatus === 'ready') {
            setInitialized(true);
        }
    }, [reportsStatus]);
    return strict ? (initialized ? children : null) : children;
};
exports.ScriptWrapper = ScriptWrapper;
var StrictScriptWrapper = function (_a) {
    var children = _a.children;
    return ((0, jsx_runtime_1.jsx)(exports.ScriptWrapper, { strict: true, children: children }));
};
exports.StrictScriptWrapper = StrictScriptWrapper;
